module.exports = __webpack_public_path__ + "static/scale-model-of-river-city-run-in-san-antonio-texas-925cc70c2d549420f9f682a950ae8c1f.png";